import ErrorBanner from './ErrorBanner'

export * from './ErrorBanner'
export default ErrorBanner
